module.exports = __webpack_public_path__ + "img/attach.968f7b58.svg";